(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spookora-cart"] && !Shopify.designMode) return;
  try {
    
async function spUpdateCart(root,path,body){
 if(root.getAttribute('aria-busy')==='true')return;
 root.setAttribute('aria-busy','true');
 root.querySelectorAll('button').forEach(button=>button.disabled=true);
 const error=root.querySelector('.sp-cart-error');if(error)error.hidden=true;
 try{
  const response=await fetch(root.dataset.root+path,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({...body,sections:[root.dataset.sectionId],sections_url:root.dataset.root+'cart'})});
  const data=await response.json();if(!response.ok)throw new Error(data.description||root.dataset.error);
  const state=path==='cart/add.js'?await (await fetch(root.dataset.root+'cart.js',{headers:{'Accept':'application/json'}})).json():data;
  const physical=(state.items||[]).filter(item=>item.variant_id!==Number(root.dataset.protectionId));
  const fees=(state.items||[]).filter(item=>item.variant_id===Number(root.dataset.protectionId));
  if(!physical.length&&fees.length){const updates={};fees.forEach(item=>updates[item.key]=0);await fetch(root.dataset.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});window.location.reload();return;}
  const html=data.sections&&data.sections[root.dataset.sectionId];
  if(!html){window.location.reload();return;}
  const fresh=new DOMParser().parseFromString(html,'text/html').getElementById(root.id);
  if(!fresh){window.location.reload();return;}
  root.replaceWith(fresh);
 }catch(exception){root.removeAttribute('aria-busy');root.querySelectorAll('button').forEach(button=>button.disabled=false);if(error){error.textContent=exception.message||root.dataset.error;error.hidden=false;}}
}
document.addEventListener('click',function(event){
 const step=event.target.closest('[data-cart-step]');const remove=event.target.closest('[data-cart-remove]');if(!step&&!remove)return;
 const control=step||remove;const line=control.closest('[data-line-key]');const root=control.closest('.sp-cart');const input=line.querySelector('[data-cart-quantity]');
 const quantity=remove?0:Math.max(0,Number(input.value)+Number(step.dataset.cartStep));
 spUpdateCart(root,'cart/change.js',{id:line.dataset.lineKey,quantity});
});
document.addEventListener('change',function(event){
 const root=event.target.closest('.sp-cart');if(!root)return;
 if(event.target.matches('[data-cart-quantity]')){const line=event.target.closest('[data-line-key]');spUpdateCart(root,'cart/change.js',{id:line.dataset.lineKey,quantity:Math.max(0,Number(event.target.value)||0)});}
 if(event.target.matches('[data-cart-protection]')){const checkbox=event.target;const keys=checkbox.dataset.keys.split(',').filter(Boolean);if(checkbox.checked&&!keys.length){spUpdateCart(root,'cart/add.js',{items:[{id:Number(root.dataset.protectionId),quantity:1}]});}else if(!checkbox.checked&&keys.length){const updates={};keys.forEach(key=>updates[key]=0);spUpdateCart(root,'cart/update.js',{updates});}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spookora-store"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const menuLink=event.target.closest('.sp-mobile-menu a');
  if(menuLink){menuLink.closest('details').removeAttribute('open');}
  const thumb=event.target.closest('[data-sp-image]');
  if(thumb){spSelectGallery(thumb.closest('.sp-gallery'),thumb.dataset.spImage);}
  const pause=event.target.closest('.sp-review-pause');
  if(pause){const section=pause.closest('.sp-reviews');const paused=section.classList.toggle('sp-paused');pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?pause.dataset.play:pause.dataset.pause;}
});
document.addEventListener('change',function(event){
  if(!event.target.matches('[data-sp-variant]'))return;
  const option=event.target.selectedOptions[0];const section=event.target.closest('.sp-product');
  section.querySelector('.sp-price').textContent=option.dataset.price;
  if(option.dataset.image){spSelectGallery(section.querySelector('.sp-gallery'),option.dataset.image);}
});
document.addEventListener('change',function(event){
  if(event.target.matches('[data-sp-tier]')){
    const root=event.target.closest('[data-sp-bundle-root]');
    root.querySelectorAll('.sp-bundle-tier').forEach(function(tier){
      const active=tier.dataset.tier===event.target.value;
      tier.classList.toggle('sp-bundle-selected',active);
      tier.querySelector('.sp-bundle-body').hidden=!active;
      tier.querySelectorAll('select').forEach(function(select){select.disabled=!active;});
    });
  }
  if(event.target.matches('[data-sp-bundle-variant]')){
    const gallery=event.target.closest('.sp-product').querySelector('.sp-gallery');
    const url=event.target.selectedOptions[0].dataset.image;
    if(url){spSelectGallery(gallery,url);}
  }
});
document.addEventListener('click',async function(event){
  const button=event.target.closest('[data-sp-add-bundle]');
  if(!button||button.disabled)return;
  event.preventDefault();
  const root=button.closest('[data-sp-bundle-root]');
  const error=root.querySelector('.sp-bundle-error');
  const original=button.textContent;
  const tier=root.querySelector('[data-sp-tier]:checked').value;
  const code=tier==='2'?'SPOOKORA-BUY2-25':tier==='3'?'SPOOKORA-BUY3-GET1':'';
  const protection=root.querySelector('[data-sp-protection]');
  const base=root.dataset.rootUrl;
  const protectionId=protection?Number(protection.value):null;
  let added=false;
  error.hidden=true;button.disabled=true;button.textContent=root.dataset.loading;
  const request=async function(path,body){
    const response=await fetch(base+path,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
    const data=await response.json();
    if(!response.ok)throw new Error(data.description||data.message||root.dataset.error);
    return data;
  };
  try{
    const cartResponse=await fetch(base+'cart.js',{headers:{'Accept':'application/json'}});
    if(!cartResponse.ok)throw new Error(root.dataset.error);
    const cart=await cartResponse.json();
    const existingProtection=cart.items.filter(function(item){return item.variant_id===protectionId;});
    if(protection&&!protection.checked&&existingProtection.length){
      const updates={};existingProtection.forEach(function(item){updates[item.key]=0;});await request('cart/update.js',{updates:updates});
    }
    const properties={};properties[root.dataset.warrantyLabel]=root.dataset.warrantyValue;
    properties._spookora_bundle=tier;
    const items=Array.from(root.querySelectorAll('.sp-bundle-selected [data-sp-bundle-variant]')).map(function(select){return {id:Number(select.value),quantity:1,properties:properties};});
    if(items.some(function(item){return !item.id;}))throw new Error(root.dataset.error);
    if(protection&&protection.checked&&!existingProtection.length)items.push({id:protectionId,quantity:1});
    await request('cart/add.js',{items:items});added=true;
    await request('cart/update.js',{discount:code});
    window.location.assign(root.dataset.cartUrl);
  }catch(exception){
    if(added&&code){window.location.assign(base+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(root.dataset.cartUrl));return;}
    if(added){window.location.assign(root.dataset.cartUrl);return;}
    error.textContent=exception.message||root.dataset.error;error.hidden=false;button.disabled=false;button.textContent=original;
  }
});


function spInitVideos(root){
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.querySelectorAll('.sp-news-player:not([data-sp-ready])').forEach(function(video){
    video.dataset.spReady='true';video.muted=true;
    video.addEventListener('volumechange',function(){if(!video.muted){document.querySelectorAll('.sp-news-player').forEach(function(other){if(other!==video)other.muted=true;});}});
    if(!reduced && 'IntersectionObserver' in window){
      const observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){video.play().catch(function(){});}else{video.pause();}});},{threshold:0.5});observer.observe(video);
    }
  });
}
spInitVideos(document);
document.addEventListener('shopify:section:load',function(event){spInitVideos(event.target);});

function spSelectGallery(gallery,url){
  if(!gallery)return;
  const track=gallery.querySelector('.sp-gallery-track');
  const slides=Array.from(track.children);
  const target=slides.find(function(slide){return slide.dataset.spSrc===url;});
  if(target){track.scrollTo({left:target.offsetLeft-track.firstElementChild.offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
}
function spInitGallery(root){
  root.querySelectorAll('[data-sp-gallery]:not([data-sp-gallery-ready])').forEach(function(gallery){
    gallery.dataset.spGalleryReady='true';
    const track=gallery.querySelector('.sp-gallery-track');
    const slides=Array.from(track.children);const thumbs=Array.from(gallery.querySelectorAll('.sp-thumb'));
    if(!slides.length)return;
    const update=function(){const index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));gallery.querySelector('.sp-gallery-count').textContent=(index+1)+' / '+slides.length;thumbs.forEach(function(thumb,i){thumb.setAttribute('aria-pressed',String(i===index));});gallery.querySelector('[data-sp-gallery-prev]').disabled=index===0;gallery.querySelector('[data-sp-gallery-next]').disabled=index===slides.length-1;};
    track.addEventListener('scroll',update,{passive:true});
    gallery.addEventListener('click',function(event){const direction=event.target.closest('[data-sp-gallery-prev],[data-sp-gallery-next]');if(direction){track.scrollBy({left:track.clientWidth*(direction.hasAttribute('data-sp-gallery-next')?1:-1),behavior:'smooth'});}});
    track.addEventListener('keydown',function(event){if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();track.scrollBy({left:track.clientWidth*(event.key==='ArrowRight'?1:-1),behavior:'smooth'});}});
    update();
  });
}
spInitGallery(document);
document.addEventListener('shopify:section:load',function(event){spInitGallery(event.target);});

  } catch(e) { console.error(e); }
})();
})();
